// WTK-767：Hotel Overview / Reviews 打开时要看到最新评论，日期一律从 Last 7 days 开始。
// 2026-10-19 先做成「选择只保留当天」，但 QA 同一天重新打开仍沿用了之前选的 Current Month / Last Month，
// 而且这个选择全站共用，换酒店也跟着走。2026-11-02 改为：hotelTime / reviewTime 不再存进 localStorage
// （store/index.js 的 persistedstate paths 里去掉了），每次打开 / 刷新页面都是 Last 7 days；
// 不刷新、在站内切页面时仍保留当前选择（Vuex 内存里的值）。

const state = {
    hotelTime: {
        type:'',
        time:'',
        frequency:'',
    },
    reviewTime:{
        type:'',
        time:'',
    },
    competitorsTime:{
        type:'',
        time:'',
        frequency:'',
    },
    RestaurantDashboardTime:{
        type:'',
        time:'',
    },
    RestaurantReviewsTime:{
        type:'',
        time:'',
    },
    reportTime:{
        reportType:'',
        timeType:'',
    },
    brandTime:{
        type:'',
        time:'',
        frequency:'',
    },
    settingsTime:{
        type:'',
        time:'',
    },
};

const mutations = {
    changeReviewTime(state, data) {
        state.reviewTime = data
    },
    changeRestaurantReviewsTime(state, data) {
        state.RestaurantReviewsTime = data
    },

    changeHotelTime(state, data) {
        state.hotelTime = data
    },
    changeCompetitorsTime(state, data) {
        state.competitorsTime = data
    },
    changeRestaurantDashboardTime(state, data) {
        state.RestaurantDashboardTime = data
    },
    changeReportTime(state, data) {
        state.reportTime = data
    },
    changeBrandTime(state, data) {
        state.brandTime = data
    },
    changeSettingsTime(state, data) {
        state.settingsTime = data
    },
    clearAllTime(state){
        // The following keys are user-persisted preferences and must NOT be reset on app load:
        // RestaurantReviewsTime, competitorsTime, RestaurantDashboardTime, brandTime
        // hotelTime / reviewTime 每次加载都清空（空 type = 页面走默认 Last 7 days），见文件顶部 WTK-767 的说明。
        // 不持久化后启动时本来就是空的；这里再清一次，兼容旧版本存在 localStorage 里的值
        state.hotelTime = { type: '', time: '', frequency: '' };
        state.reviewTime = { type: '', time: '' };
        state.reportTime = {timeType:'Week', reportType:'Hotel'}
        state.settingsTime = {type:'Last_7_days', time:''}
    },
};

export default {
    namespaced: true,
    state,
    mutations,
};
